import { cn } from "@/lib/utils";

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Stagger index for sequential shimmer (0-based). Parent can use CSS variable instead. */
  delay?: number;
}

function Skeleton({ className, delay, style, ...props }: SkeletonProps) {
  const delayStyle = delay !== undefined ? { animationDelay: `${delay * 120}ms`, ...style } : style;
  return (
    <div
      className={cn("skeleton-shimmer rounded-md bg-muted", className)}
      style={delayStyle}
      {...props}
    />
  );
}

export { Skeleton };
